<template>
  <div>
  <sidenav :orientation="orientation" class="sidenav sidenav-vertical bg-sidenav-theme layout-sidenav">

    <!-- Inner -->
    <div class="media pl-3 usercard" v-if="user">
      <div class="media-body ml-3">
        <span class="userid">{{ user.userprofile.lastname }} {{ user.userprofile.firstname }}</span>
        <div v-if="$cookie.get('language') == 'fr'" class="text-muted small usertype">{{ user.userprofile.user_type.label }}</div>
        <div v-if="$cookie.get('language') == 'en'" class="text-muted small usertype">{{ user.userprofile.user_type.label_en }}</div>
      </div>
    </div>
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">
      <div v-if="user !== null &&
      (user.userprofile.user_type.slug === 'obea_admin')">
        <sidenav-router-link icon="ion ion-ios-home" to="/" :exact="true">{{ $t('welcome')}}</sidenav-router-link>
        <sidenav-router-link icon="ion ion-md-paper" to="/documentation/" :exact="true">{{ $t('documention')}}</sidenav-router-link>
        <sidenav-router-link icon="ion ion-md-document" to="/rawresults/" :exact="true">{{ $t('welcome')}}</sidenav-router-link>
        <sidenav-router-link icon="ion ion-md-code-download" to="/reviewdeposit/" :exact="true">Dépot de rapport</sidenav-router-link>
       <sidenav-menu icon="ion ion-md-settings" :active="isMenuActive('/dashboard/reporting/')" :open="isMenuOpen('/dashboard/reporting/')">
          <template slot="link-text">Reporting</template>
          <sidenav-router-link to="/dashboard/administration/reporting/survey/">{{ $t('surveys_list')}}</sidenav-router-link>
          <sidenav-router-link to="/dashboard/administration/reporting/alerts">{{ $t('alerts')}}</sidenav-router-link>
        </sidenav-menu>
        <sidenav-menu icon="ion ion-md-settings" :active="isMenuActive('/dashboard/administration/')" :open="isMenuOpen('/dashboard/administration/')">
            <template slot="link-text">Administration</template>
            <sidenav-router-link to="/dashboard/administration/userlist/">Utilisateurs</sidenav-router-link>
            <sidenav-router-link to="/dashboard/administration/results/">Résultats d'enquête</sidenav-router-link>
            <sidenav-router-link to="/dashboard/administration/documentation/">Document Pédagogiques</sidenav-router-link>
            <sidenav-router-link to="/dashboard/administration/questionnary/">Questiothèque</sidenav-router-link>
            <sidenav-router-link to="/dashboard/administration/companies/">Structure Organisationnelle</sidenav-router-link>
            <sidenav-router-link to="/dashboard/administration/usertype/list/">Droits et  types d'utilisateurs</sidenav-router-link>
        </sidenav-menu>
      </div>
      <div v-else-if="user !== null">
        <sidenav-router-link icon="ion ion-ios-home" to="/" :exact="true">{{ $t('welcome')}}</sidenav-router-link>
        <sidenav-router-link v-if="user.userprofile.user_type.services.includes('documentation')" icon="ion ion-md-paper" to="/documentation/" :exact="true">{{ $t('documention')}}</sidenav-router-link>
        <sidenav-router-link v-if="user.userprofile.user_type.services.includes('companies')" icon="ion ion-md-bus" to="/company/" :exact="true">{{ $t('companies')}}</sidenav-router-link>
        <sidenav-router-link v-if="user.userprofile.user_type.services.includes('survey')" icon="ion ion-md-help-circle" to="/survey/" :exact="true">{{ $t('surveys_list')}}</sidenav-router-link>
        <sidenav-menu v-if="user.userprofile.user_type.services.includes('user')" icon="ion ion-md-people" :active="isMenuActive('/users/')" :open="isMenuOpen('/users/')">
              <template slot="link-text">{{ $t('users_list')}}</template>
              <sidenav-router-link to="/users/list/">Utilisateur</sidenav-router-link>
              <sidenav-router-link v-if="user.userprofile.user_type.services.includes('provider')" to="/users/providers/">{{ $t('provider')}}</sidenav-router-link>
        </sidenav-menu>
          <sidenav-router-link v-if="user.userprofile.user_type.services.includes('report') || user.userprofile.user_type.services.includes('softconcept')" icon="ion ion-md-stats" to="/get-report/" :exact="true">Accès aux résultats</sidenav-router-link>
        <sidenav-menu  icon="ion ion-md-people" :active="isMenuActive('/share/')" :open="isMenuOpen('/share/')">
              <template slot="link-text">Espace de Partage</template>
              <sidenav-router-link to="/share/inspiration/">Inspirations</sidenav-router-link>
              <sidenav-router-link to="/share/guidelines/">Bonnes pratiques</sidenav-router-link>
          </sidenav-menu>
        <sidenav-router-link icon="ion ion-md-stats" to="/bebox/" target="_blank" :exact="true">B-e Box </sidenav-router-link>
        <sidenav-router-link v-if="user.userprofile.user_type.services.includes('roadmap')" icon="ion ion-md-settings" to="/plan-actions/" :exact="true">Plan d'actions</sidenav-router-link>
          <sidenav-menu  v-if="user.userprofile.user_type.services.includes('reporting')" icon="ion ion-md-settings" :active="isMenuActive('/dashboard/reporting/')" :open="isMenuOpen('/dashboard/reporting/')">
              <template slot="link-text">Reporting</template>
              <sidenav-router-link to="/dashboard/administration/reporting/survey/">{{ $t('surveys_list')}}</sidenav-router-link>
              <sidenav-router-link to="/dashboard/administration/reporting/alerts">{{ $t('alerts')}}</sidenav-router-link>
          </sidenav-menu>
      
      </div>
    </div>
    <div class="footermenu text-center text-muted">
        <img class="mb-1" :src="require('@/assets/logo.svg')" style="height:40px;"/><br/>
        <a href="/confidentiality/">{{ $t('privacy')}}</a><br/>
        <a href="/legals/">{{ $t('legales')}}</a>&nbsp;-&nbsp;<a href="/cookies/">{{ $t('cookies_managment')}}</a>
    </div>
  </sidenav>

</div>
</template>
<style>
.footermenu {
  padding:20px;
  font-size:11px;
}
.sidenav {
  padding-top:64px;
}
.bg-sidenav-theme{
  background-color:#ffffff !important;
}
.bg-sidenav-theme .sidenav-link, .bg-sidenav-theme .sidenav-horizontal-prev, .bg-sidenav-theme .sidenav-horizontal-next {
  color: #6CB9D5;
}
.bg-sidenav-theme .sidenav-item.open:not(.sidenav-item-closing) > .sidenav-toggle, .bg-sidenav-theme .sidenav-item.active > .sidenav-link {
    color: #6CB9D5 !important;
    font-weight:bold;
}
.bg-sidenav-theme .sidenav-link:hover, .bg-sidenav-theme .sidenav-link:focus, .bg-sidenav-theme .sidenav-horizontal-prev:hover, .bg-sidenav-theme .sidenav-horizontal-prev:focus, .bg-sidenav-theme .sidenav-horizontal-next:hover, .bg-sidenav-theme .sidenav-horizontal-next:focus {
   color: #ffffff !important;
    background-color: #6CB9D5;
}
.bg-sidenav-theme .sidenav-item.active > .sidenav-link:not(.sidenav-toggle) {
    color: #ffffff !important;
    background-color: #6CB9D5;
}
.userid {
    font-size:1.3rem;
    font-weight:700;
    color:#6CB9D5 !important;
}
.usertype {
  color:#6CB9D5 !important;
}
.usercard{
  padding-top:30px;
  padding-bottom:30px;
  border-bottom:3px solid #f5f5f5;
  border-top:3px solid #f5f5f5;
  color:#6CB9D5;
}
</style>
<script>
  import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'
  import { mapState } from 'vuex';

  export default {
    name: 'app-layout-sidenav',
    components: {
      /* eslint-disable vue/no-unused-components */
      Sidenav,
      SidenavLink,
      SidenavRouterLink,
      SidenavMenu,
      SidenavHeader,
      SidenavBlock,
      SidenavDivider
      /* eslint-enable vue/no-unused-components */
    },

    props: {
      orientation: {
        type: String,
        default: 'vertical'
      }
    },

    computed: mapState({ user: state => state.user.user }),

    methods: {
      isMenuActive (url) {
        return this.$route.path.indexOf(url) === 0
      },

      isMenuOpen (url) {
        return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
      },

      toggleSidenav () {
        this.layoutHelpers.toggleCollapsed()
      }
    }
  }
</script>
